var _radialGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.384 511.384",
    height: 512,
    viewBox: "0 0 511.384 511.384",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "path3462_00000056390319734714172580000005061095503966143656_",
    cx: -456.624,
    cy: -94.548,
    gradientTransform: "matrix(453.822 0 0 -453.822 207352.422 -42727.547)",
    gradientUnits: "userSpaceOnUse",
    r: 0.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeb2d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#aeb2d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#484c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484c89"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g3438",
    transform: "matrix(1.25 0 0 -1.25 -4.4 394.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3440"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.52 110.886c0-59.427 91.584-107.603 204.553-107.603 112.97 0 204.554 48.176 204.554 107.603 0 59.426-91.584 107.603-204.554 107.603-112.969-.001-204.553-48.177-204.553-107.603",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3462",
    d: "m3.52 110.886c0-59.427 91.584-107.603 204.553-107.603 112.97 0 204.554 48.176 204.554 107.603 0 59.426-91.584 107.603-204.554 107.603-112.969-.001-204.553-48.177-204.553-107.603",
    fill: "url(#path3462_00000056390319734714172580000005061095503966143656_)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g3464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3472",
    transform: "translate(288 27.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3474",
    d: "m-79.927-16.087c108.557 0 196.563 44.599 196.563 99.614 0 55.014-88.006 99.614-196.563 99.614s-196.563-44.6-196.563-99.614c0-55.016 88.006-99.614 196.563-99.614",
    fill: "#777bb3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3484",
    transform: "translate(161.734 145.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3486",
    d: "m-47.079-46.772c8.926 0 15.59 1.646 19.806 4.891 4.171 3.212 7.052 8.776 8.562 16.538 1.408 7.255.872 12.321-1.594 15.054-2.521 2.792-7.97 4.208-16.198 4.208h-14.265l-7.908-40.692h11.597zm-46.657-50.124c-.662 0-1.291.296-1.712.808-.422.511-.593 1.184-.466 1.835l20.959 107.833c.203 1.042 1.116 1.796 2.179 1.796h45.171c14.196 0 24.763-3.855 31.404-11.458 6.677-7.643 8.739-18.328 6.128-31.755-1.062-5.47-2.89-10.551-5.431-15.1-2.544-4.554-5.907-8.767-9.996-12.526-4.895-4.581-10.435-7.903-16.451-9.858-5.921-1.929-13.525-2.907-22.601-2.907h-18.291l-5.224-26.872c-.203-1.043-1.116-1.796-2.178-1.796z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3488",
    transform: "translate(159.224 197.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3490",
    d: "m-46.425-60.3h12.435c9.929 0 13.379-2.179 14.551-3.477 1.944-2.156 2.311-6.702 1.062-13.145-1.404-7.213-4.007-12.328-7.737-15.2-3.819-2.94-10.028-4.43-18.453-4.43h-8.903zm21.33 25.895h-45.171c-2.125 0-3.952-1.506-4.357-3.592l-20.958-107.834c-.253-1.301.089-2.647.931-3.67.843-1.023 2.1-1.615 3.426-1.615h23.49c2.126 0 3.952 1.506 4.358 3.592l4.874 25.077h16.461c9.309 0 17.145 1.015 23.29 3.016 6.319 2.053 12.133 5.534 17.278 10.346 4.256 3.915 7.761 8.31 10.417 13.064 2.657 4.755 4.566 10.058 5.673 15.76 2.749 14.134.516 25.452-6.636 33.638-7.082 8.107-18.211 12.218-33.076 12.218m-33.761-66.586h14.289c9.471 0 16.525 1.784 21.16 5.352 4.636 3.569 7.762 9.526 9.387 17.872 1.554 8.014.846 13.669-2.124 16.964-2.974 3.295-8.922 4.942-17.846 4.942h-16.095zm33.761 62.147c13.589 0 23.502-3.566 29.733-10.699 6.23-7.133 8.107-17.089 5.621-29.871-1.023-5.266-2.754-10.08-5.19-14.441-2.439-4.364-5.624-8.355-9.56-11.974-4.691-4.39-9.901-7.518-15.635-9.381-5.734-1.868-13.037-2.798-21.915-2.798h-20.121l-5.572-28.669h-23.49l20.958 107.833z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3492",
    transform: "translate(311.583 116.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3494",
    d: "m-86.062-39.227c-.663 0-1.291.296-1.712.808-.422.511-.593 1.184-.467 1.835l9.271 47.712c.882 4.537.664 7.794-.612 9.17-.781.841-3.128 2.252-10.067 2.252h-16.796l-11.656-59.981c-.203-1.043-1.116-1.796-2.179-1.796h-23.305c-.663 0-1.291.296-1.713.808-.422.511-.593 1.184-.466 1.835l20.958 107.834c.203 1.042 1.116 1.796 2.179 1.796h23.305c.663 0 1.291-.296 1.713-.807.422-.512.593-1.184.466-1.836l-5.058-26.026h18.069c13.765 0 23.099-2.427 28.535-7.419 5.542-5.093 7.27-13.237 5.14-24.207l-9.751-50.18c-.203-1.043-1.116-1.796-2.179-1.796h-23.675z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3496",
    transform: "translate(293.661 271.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3498",
    d: "m-81.4-79.486h-23.305c-2.126 0-3.952-1.506-4.358-3.592l-20.958-107.834c-.253-1.301.089-2.647.932-3.67s2.1-1.615 3.426-1.615h23.305c2.125 0 3.952 1.506 4.358 3.592l11.307 58.185h14.966c6.927 0 8.381-1.48 8.439-1.543.42-.452.973-2.546.061-7.236l-9.271-47.712c-.253-1.301.089-2.647.932-3.67s2.1-1.615 3.426-1.615h23.675c2.125 0 3.952 1.506 4.358 3.592l9.75 50.18c2.288 11.779.331 20.615-5.816 26.265-5.866 5.387-15.691 8.005-30.037 8.005h-15.377l4.545 23.383c.252 1.301-.089 2.648-.932 3.67-.844 1.022-2.1 1.615-3.426 1.615m0-4.439-5.572-28.669h20.762c13.064 0 22.074-2.28 27.033-6.835 4.959-4.557 6.445-11.942 4.463-22.15l-9.751-50.179h-23.675l9.271 47.711c1.055 5.428.667 9.13-1.164 11.104-1.833 1.974-5.731 2.962-11.693 2.962h-18.626l-12.005-61.777h-23.305l20.958 107.833z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3500",
    transform: "translate(409.55 145.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3502",
    d: "m-111.548-46.772c8.926 0 15.59 1.646 19.806 4.891 4.171 3.211 7.052 8.775 8.563 16.538 1.408 7.255.872 12.321-1.594 15.054-2.521 2.792-7.97 4.208-16.197 4.208h-14.265l-7.908-40.692h11.595zm-46.657-50.124c-.662 0-1.291.296-1.712.808-.422.511-.593 1.184-.467 1.835l20.958 107.834c.203 1.042 1.116 1.796 2.18 1.796h45.17c14.197 0 24.763-3.855 31.405-11.458 6.677-7.643 8.738-18.327 6.128-31.755-1.064-5.47-2.891-10.551-5.432-15.1-2.544-4.554-5.907-8.767-9.996-12.526-4.895-4.581-10.435-7.903-16.451-9.858-5.921-1.929-13.525-2.907-22.601-2.907h-18.291l-5.221-26.873c-.203-1.043-1.116-1.796-2.18-1.796z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3504",
    transform: "translate(407.039 197.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3506",
    d: "m-110.895-60.3h12.435c9.93 0 13.379-2.179 14.551-3.477 1.945-2.156 2.312-6.702 1.062-13.144-1.404-7.214-4.008-12.329-7.737-15.201-3.819-2.94-10.028-4.43-18.453-4.43h-8.903zm21.33 25.895h-45.171c-2.125 0-3.952-1.506-4.357-3.592l-20.958-107.834c-.253-1.301.089-2.647.931-3.67.843-1.023 2.1-1.615 3.426-1.615h23.49c2.125 0 3.952 1.506 4.358 3.592l4.873 25.077h16.461c9.309 0 17.145 1.015 23.29 3.016 6.319 2.053 12.134 5.535 17.28 10.348 4.256 3.914 7.76 8.308 10.416 13.062 2.657 4.755 4.566 10.058 5.673 15.76 2.749 14.135.516 25.453-6.636 33.639-7.082 8.106-18.21 12.217-33.076 12.217m-33.76-66.586h14.288c9.471 0 16.525 1.784 21.16 5.352 4.637 3.569 7.762 9.526 9.387 17.872 1.555 8.014.847 13.669-2.124 16.964-2.974 3.295-8.922 4.942-17.846 4.942h-16.095zm33.76 62.147c13.589 0 23.502-3.566 29.733-10.699s8.106-17.089 5.621-29.871c-1.023-5.266-2.754-10.08-5.19-14.441-2.439-4.364-5.624-8.355-9.56-11.974-4.691-4.39-9.901-7.518-15.635-9.381-5.734-1.868-13.037-2.798-21.915-2.798h-20.121l-5.571-28.669h-23.49l20.958 107.833z",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.890d22e95c51767df111b14eb0c52c0a.svg";
export { ForwardRef as ReactComponent };